module.exports = __webpack_public_path__ + "img/william-still.4aa66cc9.png";